<script>
   /***************************************************************
    * Select                                                      *
    * --------------------                                        *
    * control element for selecting among a few options           *
    ***************************************************************/

   export let id;                         // text ID of the input element
   export let options;                    // array with all options
   export let value = options[0];         // initial selected value

   /**
    * Handler of event when changes are made by pressing left and right arrows
    * @param e
    */
   const changeOption = (e) => {
      if (e.key === 'ArrowLeft') {
         const ind = options.findIndex(v => v === value);
         if (ind > 0) {
            value = options[ind - 1];
         }
         return
      }

      if (e.key === 'ArrowRight') {
         const ind = options.findIndex(v => v === value);
         if (ind < options.length) {
            value = options[ind + 1];
         }
         return
      }
   }

</script>

<div on:keydown={changeOption} role="radiogroup" tabindex="0" class="selector">
   {#each options as option (option)}
   <button on:click={() => value = option} class="option option_{option}" class:selected={option==value}>
   {@html option}
   </button>
   {/each}
</div>
<input name={id} bind:value={value}>

<style>
   input {
      display: none;
   }

   .selector {
      position: relative;
      box-sizing: border-box;
      flex: 1 1 auto;
      font-size: 1em;
      line-height: 1.5em;
      margin: 0;
      padding: 0.15em 0;
      width: auto;
      border-radius: 2px;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      display: flex;
   }

   .option {
      cursor: default;
      padding: 0.25em 0.5em;
      margin: 0 0.2em 0 0;
      color: #606060;
      background-color: #f0f0f0;
      border: 1px solid transparent;
      border-radius: 0.3em;
   }

   .option.selected {
      background-color: #6EB8FF;
      color: #fefefe;
   }

   .option:not(.selected):hover {
      border: 1px solid #66abec;
      background-color: #6eb8ff20;
      color: #4777a4;
   }
</style>